export default __webpack_public_path__ + "static/looksmutable-388aa92b5f64fd825cfb13975deaf112.jpeg";